























import { UiSelect } from '../keen-ui';
import Searchbox from '../searchbox.component.vue';

export default {
  name: 'configurations-search-input',
  props: {
    tags: {
      type: Array,
      default: () => []
    },
    selectedTag: {
      type: String,
      default: ''
    },
    tagsLabel: String,
    queryLabel: String,
    queryPlaceholder: String,
    queryHelp: String,
    border: Boolean
  },
  components: {
    UiSelect,
    Searchbox
  },
  computed: {
    queryMaxLength: function (): number {
      return 80 - (!!this.selectedTag && this.selectedTag.length);
    }
  },
  data: function () {
    return {
      query: ''
    };
  },
  methods: {
    onQueryChange: function (query: string): void {
      this.query = query;
      this.$emit('queryChange', query);
    }
  }
};

